import type { SxProps, Theme } from '@mui/material';

export const membershipsLayoutSx: SxProps<Theme> = {
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
};

export const membershipsLayoutBlockContentSx: SxProps<Theme> = {
  padding: 0,
};

export const previewBodySecondarySx: SxProps<Theme> = {
  opacity: 0.9,
};

export const previewBodyTertiarySx: SxProps<Theme> = {
  opacity: 0.7,
  mt: 2,
};

export const saveButtonSx: SxProps<Theme> = {
  py: 1.5,
  textTransform: 'none',
  fontWeight: 500,
};

export const configLoadingSkeletonSx: SxProps<Theme> = {
  width: '100%',
  p: 2,
};

export const membershipsBlockContentProps = {
  sx: membershipsLayoutBlockContentSx,
};
